import { render, staticRenderFns } from "./ReferralPanel.vue?vue&type=template&id=50295338&"
import script from "./ReferralPanel.vue?vue&type=script&lang=js&"
export * from "./ReferralPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports